<!--
 * @Description: 
 * @Version: 2.5.2
 * @Autor: jzt
 * @Date: 2024-01-01 10:00:00
 * @LastEditors: jzt
 * @LastEditTime: 2024-01-01 10:00:00
-->
<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  created() {
    // console.log('$utilsPublic: ',this.$utilsPublic);
    // console.log('env:',process.env)
  }
}
</script>

<style>
  @font-face { font-family: 'ysft_Medium';src: url('./assets/css/ybft.ttf'); }
  /* @font-face { font-family: 'HarmonyOS';src: url('./assets/css/HarmonyOS_Sans_SC_Regular.ttf'); } */
  @font-face { font-family: 'OpSans';src: local('PingFang SC'),local('Microsoft YaHei') }

  * { margin: 0;padding: 0;list-style: none; }
  * { -webkit-tap-highlight-color: transparent; }
  html,body,#app { height: 100%;background: #fff; }
  .w1050 { width: 1050px;margin: 0 auto; }
  .w1200 { max-width: 1200px;margin: 0 auto;padding: 0 16px; }
  .w104 { width: 104px; } .mt40 { margin-top: 40px; }
  .h100 { height: 100%; }
  .m240 { width: 240px; } .borderyelllow { border: 1px solid #ffddc1; }
  .pointer {cursor: pointer;user-select: none;}
  .dpNone { display: none; }
  .zoomIn { cursor: zoom-in; }
  .textCenter{ text-align: center; }
  .overHidden { overflow: hidden; }
  .overAuto { overflow: auto; }
  .oneline { white-space: nowrap;overflow: hidden;text-overflow: ellipsis; }
  .emptyTable { background: url('./assets/img/empty.png') center / contain no-repeat;max-width: 357px;min-height: 120px;margin: 0 auto; }
  /* .v-modal { opacity: 1;backdrop-filter: blur(2px);background: rgba(0, 0, 0, 0.45); } */
  
  .disflex { display: flex;flex-direction: column;height: 100%; }
  .flex_bottom { flex: 1;overflow: auto; }
  .flex_start { display: flex;align-items: center;justify-content: flex-start; }
  .flex-dim-list { display: flex;flex: 1;flex-wrap: wrap;align-items: center; }
  .flex_center { display: flex;align-content: center;justify-content: center;align-items: center; }
  .flex { display: flex !important; }
  .flex1 { flex: 1; }
  .flexCol { flex-direction: column; }
  .flexWrap { flex-wrap: wrap;align-content: flex-start; }
  .flexBtw { justify-content: space-between; }
  .flexCenter { align-items: center; }
  .flextextCenter { justify-content: center; }
  .lh18 { line-height: 18px; }
  .lh20 { line-height: 20px; }
  .lh24 { line-height: 24px; }
  .lh28 { line-height: 28px; }
  .lh32 { line-height: 32px; }

  .ml2  {margin-left:  2px;} .ml5  {margin-left:  5px;} .ml6  {margin-left:  6px;} .ml8  {margin-left:  8px;} .ml10 {margin-left:  10px;}
  .ml12 {margin-left: 12px;} .ml15 {margin-left: 15px;} .ml16 {margin-left: 16px;} .ml18 {margin-left: 18px;} .ml20 {margin-left:  20px;}
  .mr2 {margin-right:  2px;} .mr5  {margin-right: 5px;} .mr6  {margin-right: 6px;} .mr8  {margin-right: 8px;} .mr10 {margin-right: 10px;}
  .mr12 {margin-right:12px;} .mr15 {margin-right:15px;} .mr16 {margin-right:16px;} .mr18 {margin-right:18px;} .mr20 {margin-right: 20px;}
  .pd6 { padding: 6px; } .pd12 { padding: 12px; } .pd14 { padding: 14px; } .pd20 { padding: 20px; } .pd24 { padding: 24px; }
  .fz10 { font-size: 10px; } .fz12 { font-size: 12px; } .fz14 { font-size: 14px; } .fz16 { font-size: 16px; } .fz18 { font-size: 18px; } 
  .fz20 { font-size: 20px; } .fz22 { font-size: 22px; } .fz24 { font-size: 24px; } .fz26 { font-size: 26px; } .fz28 { font-size: 28px; }
  .fw4 { font-weight: 400; } .fw6 { font-weight: 600; } .fw9 { font-weight: 900; }
  .gap2  { gap:  2px; } .gap4  { gap:  4px; } .gap6  { gap:  6px; } .gap8  { gap:  8px; } .gap10 { gap: 10px; }
  .gap12 { gap: 12px; } .gap14 { gap: 14px; } .gap16 { gap: 16px; } .gap18 { gap: 18px; } .gap20 { gap: 20px; } 
  .gap22 { gap: 22px; } .gap24 { gap: 24px; } .gap26 { gap: 26px; } .gap28 { gap: 28px; } .gap30 { gap: 30px; }
  
  .c476AF8Btn { letter-spacing: 2px;min-width: 120px;padding: 10px 20px;background: #3B60F6 !important;border-color: #3B60F6 !important;color: #fff !important; }
  .c476AF8Btn:hover { background: #476AF8 !important;color: #fff !important; }
  .cFEFEFEBtn { letter-spacing: 2px;min-width: 120px;padding: 10px 20px;background: #EAEBF2 !important;border-color: #EAEBF2 !important;color: #323333 !important; }
  .cFEFEFEBtn:hover { background: #f2f3f5 !important;color: #323333 !important; }
  .c3B60F6Btn { letter-spacing: 2px;min-width: 120px;padding: 10px 20px;background: rgba(59,96,246,0.14) !important;border-color: rgb(59,96,246,0.8) !important;color: rgb(59,96,246) !important; }
  .c3B60F6Btn:hover { background: #476AF8 !important;color: rgb(255,255,255) !important; }
  .lineDashed { background: linear-gradient(to left,transparent 0%,transparent 50%,#D4D9E2 50%,#D4D9E2 100%);background-size: 10px 1px;background-repeat: repeat-x;height: 1px; }

  /* pagetitle */
  .pagetitle { height: 45px;display: flex;justify-content: center;align-items: center;overflow: hidden;margin: 0 auto; padding: 72px 0 44px;gap: 30px; }
  .pagetitle .t { color:#000;font-size: 28px;font-weight: 600;text-align: center;position: relative;/* font-family: 'ysft-Medium'; */ }
  .pagetitle .t>span:nth-child(1) { position: relative;z-index: 1; }
  .pagetitle .t .ys { color: #E6E6E6;font-size: 28px;white-space: nowrap;position: absolute;top: -12px;left: 50%;transform: translate(-50%,0); }
  .pagetitle .t .y_s { display: flex;justify-content: center;gap: 3px;margin-top: 6px; }
  .pagetitle .t .y_s>i { width: 12px;height: 4px;border-radius: 5px;background: #1CA2F9; }
  .pagetitle .t .y_s>i:nth-child(2) { width: 45px;background: #66CCFF; }
  .pagetitle .ico { display: flex;align-items: center;transform: scale(0.8);display: none; }
  .pagetitle .ico i { transform: rotate(45deg); }
  .pagetitle .ico .i1 { width: 26px;height: 26px;background: #3B60F6;position: relative;z-index: 1; }
  .pagetitle .ico .i2 { width: 20px;height: 20px;background: #7690F9;position: relative;z-index: 2; }
  .pagetitle .ico .i3 { width: 16px;height: 16px;background: #BBC8FF;position: relative;z-index: 3; }

  *::-webkit-scrollbar { width: 8px; height: 8px; }
  *::-webkit-scrollbar-thumb { -webkit-box-shadow: inset 0 0 5px rgba(20, 5, 5, 0.05);background: #D9E1F0;border-radius: 10px; }
  *::-webkit-scrollbar-track { -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0);background: #fff; }

  @media all and (max-width:600px) {
    .mob_ml2  {margin-left:  2px;} .mob_ml5  {margin-left:  5px;} .mob_ml6  {margin-left:  6px;} .mob_ml8  {margin-left:  8px;} .mob_ml10 {margin-left:  10px;}
    .mob_ml12 {margin-left: 12px;} .mob_ml15 {margin-left: 15px;} .mob_ml16 {margin-left: 16px;} .mob_ml18 {margin-left: 18px;} .mob_ml20 {margin-left:  20px;}
    .mob_mr2 {margin-right:  2px;} .mob_mr5  {margin-right: 5px;} .mob_mr6  {margin-right: 6px;} .mob_mr8  {margin-right: 8px;} .mob_mr10 {margin-right: 10px;}
    .mob_mr12 {margin-right:12px;} .mob_mr15 {margin-right:15px;} .mob_mr16 {margin-right:16px;} .mob_mr18 {margin-right:18px;} .mob_mr20 {margin-right: 20px;}
    .mob_fz10 { font-size: 10px; } .mob_fz12 { font-size: 12px; } .mob_fz14 { font-size: 14px; } .mob_fz16 { font-size: 16px; } .mob_fz18 { font-size: 18px; } 
    .mob_fz20 { font-size: 20px; } .mob_fz22 { font-size: 22px; } .mob_fz24 { font-size: 24px; } .mob_fz26 { font-size: 26px; } .mob_fz28 { font-size: 28px; }
    .mob_fw4 { font-weight: 400; } .mob_fw6 { font-weight: 600; } .mob_fw9 { font-weight: 900; }
    .mob_gap2  { gap:  2px; } .mob_gap4  { gap:  4px; } .mob_gap6  { gap:  6px; } .mob_gap8  { gap:  8px; } .mob_gap10 { gap: 10px; }
    .mob_gap12 { gap: 12px; } .mob_gap14 { gap: 14px; } .mob_gap16 { gap: 16px; } .mob_gap18 { gap: 18px; } .mob_gap20 { gap: 20px; } 
    .mob_gap22 { gap: 22px; } .mob_gap24 { gap: 24px; } .mob_gap26 { gap: 26px; } .mob_gap28 { gap: 28px; } .mob_gap30 { gap: 30px; }
    *::-webkit-scrollbar { width: 0; height: 0; }
  }
  @media all and (max-width: 800px) {
    .pagetitle { padding: 40px 0px 24px; }
    .pagetitle .t { font-size: 18px; }
    .pagetitle { gap: 12px; }
    .pagetitle .ico { transform: scale(0.7); }
  }
</style>


// WEBPACK FOOTER //
// src/App.vue